/**
 * Lives in its own import-free module so `types/MediaConstants` can use it without importing
 * `DocumentCreate.api.types`. That module's imports lead back through `media.utils` to
 * `MediaConstants`, and whichever module in the cycle loads first reads the others' constants as
 * `undefined` (it surfaced as NaN folder ids in `folderIdsExcludedFromFiltering`).
 */
export enum DocumentFileType {
    None = 0,
    Word = 1,
    Excel = 2,
    PowerPoint = 3,
}
